import {MenuBookOutlined as GuidesIcon} from "@mui/icons-material";
import {getGuides, getGuideById, saveGuide, updateGuide, deleteGuide} from "../../services/GuideService";
import {getGuideCategories, saveGuideCategory, updateGuideCategory, deleteGuideCategory} from "../../services/GuideCategoryService";
import {getGuideTags, saveGuideTag, updateGuideTag, deleteGuideTag} from "../../services/GuideTagService";
import {MAX_DIRECT_VIDEO_UPLOAD_MB} from "../../utils/videoUtils";

const guidesConfig = {
    key: "guides",
    // Video bytes upload directly to S3 before the guide metadata is saved.
    videoUploadMaxSizeMb: MAX_DIRECT_VIDEO_UPLOAD_MB,
    mainIcon: GuidesIcon,
    service: {
        getList: getGuides,
        getById: getGuideById,
        save: saveGuide,
        update: updateGuide,
        remove: deleteGuide,
    },
    categoryService: {
        getCategories: getGuideCategories,
        saveCategory: saveGuideCategory,
        updateCategory: updateGuideCategory,
        deleteCategory: deleteGuideCategory,
    },
    tagService: {
        getTags: getGuideTags,
        saveTag: saveGuideTag,
        updateTag: updateGuideTag,
        deleteTag: deleteGuideTag,
    },
    labels: {
        pageTitle: "מדריכים",
        pageSubtitle: "ניהול מדריכים וקטגוריות",
        newItemButton: "מדריך חדש",
        newCategoryButton: "קטגוריה חדשה",
        tabMain: "מדריכים",
        tabCategories: "קטגוריות",
        tabTags: "תגיות",
        newTagButton: "תגית חדשה",
        tagsCardTitle: "תגיות מדריכים",
        tagsLabel: "תגיות",
        allTags: "כל התגיות",
        tagDeleteConfirm: "מחיקת תגית תסיר אותה מכל המדריכים המשויכים. להמשיך?",
        countSuffix: "מדריכים",
        searchPlaceholder: "חיפוש מדריך...",
        emptyTitle: "אין מדריכים",
        emptyHint: 'לחץ על "מדריך חדש" כדי להוסיף',
        allCategories: "כל הקטגוריות",
        categoriesCardTitle: "קטגוריות מדריכים",
        categoryDeleteConfirm: "מחיקת קטגוריה תסיר אותה מכל המדריכים המשויכים. להמשיך?",
        deleteConfirmText: "אתה בטוח רוצה למחוק את המדריך? פעולה זו לא ניתנת לביטול",
        dialog: {
            viewTitle: "צפייה במדריך",
            editTitle: "עריכת מדריך",
            createTitle: "העלאת מדריך חדש",
            saveButton: "שמירת מדריך",
            titlePlaceholder: "הזינו כותרת למדריך",
            saveError: "שגיאה בשמירת המדריך",
        },
    },
};

export default guidesConfig;
